export default "__VITE_ASSET__CvhdxI6$__"